import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: 0,
  month: null,
  year: null,
  duplicate: null,
  has_note: null,
  unreachable_submitter: null,
  submit_place: null,
  from: null,
  to: null,
  query: null,
  published: null,
  manager_id: null,
  inquirer_key: null,
  inquirer_value: null,
  pendingData: [],
  confirm: false,
  managerDecision: null,
  awaiting_confirmation: null,
};

const contentBuyerSlice = createSlice({
  name: "contentBuyerSlice",
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setMonth: (state, action) => {
      state.month = action.payload;
    },
    setYear: (state, action) => {
      state.year = action.payload;
    },
    setDuplicates: (state, action) => {
      state.duplicate = action.payload;
    },
    setHasNote: (state, action) => {
      state.has_note = action.payload;
    },
    setUnreachableSubmitter: (state, action) => {
      state.unreachable_submitter = action.payload;
    },
    setSubmitPlace: (state, action) => {
      state.submit_place = action.payload;
    },
    setFrom: (state, action) => {
      state.from = action.payload;
    },
    setTo: (state, action) => {
      state.to = action.payload;
    },
    updateQuery: (state, action) => {
      state.query = action.payload;
    },
    updateData: (state, action) => {
      state.pendingData = action.payload;
    },
    setManagerId: (state, action) => {
      state.manager_id = action.payload;
    },
    setPublished: (state, action) => {
      state.published = action.payload;
    },
    setInquirerKey: (state, action) => {
      state.inquirer_key = action.payload;
    },
    setInquirerValue: (state, action) => {
      state.inquirer_value = action.payload;
    },
    setConfirm: (state, action) => {
      state.confirm = action.payload;
    },
    setManagerDecision: (state, action) => {
      state.managerDecision = action.payload;
    },
    setAwaitingConfirmation: (state, action) => {
      state.awaiting_confirmation = action.payload;
    },
  },
});

export const {
  setStatus,
  setMonth,
  setYear,
  setDuplicates,
  setHasNote,
  setUnreachableSubmitter,
  setSubmitPlace,
  setFrom,
  setTo,
  updateQuery,
  updateData,
  setPublished,
  setManagerId,
  setInquirerKey,
  setInquirerValue,
  setConfirm,
  setManagerDecision,
  setAwaitingConfirmation,
} = contentBuyerSlice.actions;

export default contentBuyerSlice.reducer;
